import { SerializedWidget } from 'fym-common/src/db/serializersTypes';

/** The uuid of the block that a create call added: the one in the answer that was not on the page before. */
export function newWidgetUUID(
  before: readonly SerializedWidget[] | null,
  after: readonly SerializedWidget[] | null
): string | null {
  const known = new Set((before ?? []).map((widget) => widget.uuid));
  return (after ?? []).find((widget) => !known.has(widget.uuid))?.uuid ?? null;
}
